import { createFileRoute } from '@tanstack/react-router'

import SubmissionKelasKemampuanPage from '@/components/pages/backoffice/_klb-petani/_poktan/_$poktanId/kelas-kemampuan/submission/containers/SubmissionKelasKemampuanPage'

export const Route = createFileRoute(
  '/_backoffice/klb-petani/poktan/$poktanId/kelas-kemampuan/submission/'
)({
  component: SubmissionKelasKemampuanPage
})
